module.exports = __webpack_public_path__ + "assets/img/gift-8-7eb014bb.png";